'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { AccordionTitle } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components/AccordionTitle/AccordionTitle'

export function ByPostTitle() {
	const { t } = useLabels()

	return (
		<AccordionTitle
			data-testid='myPurchases.online.details.returns.byPost'
			title={t('myPurchases.online.details.returns.byPost.title')}
			cost={t('myPurchases.online.details.returns.hasCost.text')}
		/>
	)
}
